import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";

import { IUserProfile } from "MVVM/@types";
import { GET_PROFILE_CARD_DATA } from "../../GraphQL/user";
import { useUser } from "../../Hooks/useUser";

interface IProfileCardViewModel {
  user: IUserProfile | null;
  loading: boolean;
  error: string | null;
}

export const useProfileCardViewModel = ({
  username,
}: {
  username?: string;
}): IProfileCardViewModel => {
  const [getUserProfile, { loading, error, data }] = useLazyQuery(
    GET_PROFILE_CARD_DATA,
    {
      errorPolicy: "all",
      fetchPolicy: "cache-first",
    },
  );

  const { allstarUser } = useUser();

  useEffect(() => {
    if (username && username.trim()) {
      getUserProfile({
        variables: { username: username.trim() },
      });
    }
  }, [username, getUserProfile]);

  const user: IUserProfile | null = data?.user
    ? {
        ...data.user,
        username:
          data.user.username ||
          data.user.steam?.personaname ||
          data.user.riot?.riotId ||
          "User",
        isOwnProfile: allstarUser?.user?._id === data.user._id,
      }
    : null;

  return {
    user,
    loading,
    error: error?.message || null,
  };
};
